import {Component, OnInit, Optional} from '@angular/core';
import {QueryBuilderConfig, RuleSet} from "ngx-angular-query-builder";
import {PerPersonnelService} from "../../../personnel-operations/service/per-personnel-service";
import {PerEntityList} from "../../../personnel-operations/model/per-entity-list";
import {HvlFormGroup} from "@hvlng/framework-bff/core";
import {PerAdvancedSearchQueryModel} from "../../../personnel-operations/model/per-advanced-search-query-model";
import {UntypedFormArray} from "@angular/forms";
import {PerAdvancedSearchEntityModel} from "../../../personnel-operations/model/per-advanced-search-entity-model";
import {PerAdvancedSearchRuleModel} from "../../../personnel-operations/model/per-advanced-search-rule-model";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {UiToastMessageService, UiTranslateLoaderService} from "ui-shared";
import {
    OrganizationDefinitionModel
} from "../../../organization/organization-picker/model/organization-definition-model";
import {PerPeopleModel} from "../../../../model/per-people-model";
import {PerPersonnelModel} from "../../../personnel-operations/model/per-personnel-model";
import {PositionModel} from "../../../organization/position-management/model/position-model";
import {
    PerObjectDefinitionService
} from "../../../organization/object-management/object-definition/service/per-object-definition-service";


@Component({
    selector: 'personnel-advanced-search-form',
    templateUrl: './personnel-advanced-search-form.component.html',
})

export class PersonnelAdvancedSearchFormComponent implements OnInit {
    query: RuleSet;
    selectedTable;
    tableList = this.perEntityList.getEntityListForAdvancedSearch();
    config: QueryBuilderConfig;
    entityConfigMap: Map<string, QueryBuilderConfig> = new Map<string, QueryBuilderConfig>();
    form: HvlFormGroup<PerAdvancedSearchQueryModel> = new HvlFormGroup<PerAdvancedSearchQueryModel>(
        new PerAdvancedSearchQueryModel(),
    );
    model = new PerAdvancedSearchQueryModel();

    attributeList = [];
    operatorList = [
        {name: "=", value: "="},
        {name: "!=", value: "!="},
        {name: "<=", value: "<="},
        {name: ">=", value: ">="},
        {name: "like", value: "like"},
        {name: "in", value: "in"},
        {name: "not in", value: "notin"},
    ]
    selectedFieldData = [];
    advancedSearchQueryModel;
    isReady = false;
    pickerData = []


    constructor(private personnelService: PerPersonnelService,
                private perEntityList: PerEntityList,
                @Optional() public dynamicDialogRef: DynamicDialogRef,
                @Optional() private dialogConfig: DynamicDialogConfig,
                private uiTranslateService: UiTranslateLoaderService,
                private uiToastMessage: UiToastMessageService,
                private perObjectDefinitionService: PerObjectDefinitionService) {
    }

    ngOnInit() {
        this.advancedSearchQueryModel = this.dialogConfig.data.advancedSearchQueryModel;
        if (this.advancedSearchQueryModel?.length > 0) {
            this.advancedSearchQueryModel.forEach((item, index) => {
                let model = new PerAdvancedSearchEntityModel()
                model.rules = [new PerAdvancedSearchRuleModel()]
                this.formArrayList.push(new HvlFormGroup<PerAdvancedSearchEntityModel>(model));
                let entityData = this.perEntityList.findAttributeByNameFlat(item.rules[0].field)
                this.pickerData.push(this.getPickerData(item.rules[0], entityData));

                this.getEntityInfo(item.rules[0].entity, index, item.rules[0]?.field)

            })
            this.form.controls['entityModel'].patchValue(this.advancedSearchQueryModel);
            this.model.entityModel = this.advancedSearchQueryModel;

            this.isReady = true
        } else {
            this.isReady = true
        }
        if (this.advancedSearchQueryModel?.length == 0) {
            this.addItem()
        }

    }

    get formArrayList() {
        return this.form.controls['entityModel'] as UntypedFormArray;
    }

    addItem() {
        let model = new PerAdvancedSearchEntityModel()
        model.rules = [new PerAdvancedSearchRuleModel()]
        this.formArrayList.push(new HvlFormGroup<PerAdvancedSearchEntityModel>(model));
        this.model.entityModel.push(model)
    }

    getEntityInfo(selectedTable, index, field?) {
        this.form.controls.entityModel['controls'][index].get('rules').controls[0].get('entity').setValue(selectedTable)
        let data = this.perEntityList.getEntityAttrListForAdvancedSearch()
        this.attributeList[index] = [];
        data.find(x => x.entityName === selectedTable).attributes?.forEach(item => {

            this.attributeList[index].push({
                ...item,
                value: item.name,
                text: this.uiTranslateService.instant('hrPerPersonnel.detailSearch.' + item.name)
            })
        })
        if (field) {
            this.fieldOnChange(field, index)
        }

    }

    fieldOnChange(e, index) {
        this.selectedFieldData[index] = {};
        let selectedField = this.form.controls.entityModel['controls'][index]?.controls['rules']?.controls[0]?.get('field').value
        let selectedEntity = this.form.controls.entityModel['controls'][index]?.controls['rules']?.controls[0]?.get('entity').value
        this.selectedFieldData[index] = this.perEntityList.getEntityAttrListForAdvancedSearch().find(item => item.entityName === selectedEntity).attributes.find(x => x.name == e)
        // this.form.controls.entityModel['controls'][index]?.controls['rules']?.controls[0]?.get('entity').setValue(this.selectedFieldData.entity)
        this.form.controls.entityModel['controls'][index]?.controls['rules']?.controls[0]?.get('type').setValue(this.selectedFieldData[index].type)
        this.setOperators(this.selectedFieldData[index]?.comType);
    }

    setOperators(comType) {
        if (comType == "String") {
            this.operatorList = [
                {name: "=", value: "="},
                {name: "like(benzer)", value: "like"},
                {name: "!=", value: "!="},
                {name: "contains(içerir)", value: "contains"}
            ]
        } else if (comType == "category") {
            this.operatorList = [
                {name: "=", value: "="},
                {name: "in (içinde)", value: "in"},
                {name: "not in !=", value: "notin"},
            ]
        } else if (comType == "Date") {
            this.operatorList = [
                {name: "=", value: "="},
                {name: "!=", value: "!="},
                {name: ">=", value: ">="},
                {name: "<=", value: "<="},
                {name: "<", value: "<"},
                {name: ">", value: ">"},
            ]
        } else if (comType == "number") {
            this.operatorList = [
                {name: "=", value: "="},
                {name: "!=", value: "!="},
                {name: ">=", value: ">="},
                {name: "<=", value: "<="},
                {name: "<", value: "<"},
                {name: ">", value: ">"},
            ]
        } else if (comType == "picker") {
             this.operatorList = [
                {name: "=", value: "="},
                {name: "in (içinde)", value: "in"},
                {name: "not in !=", value: "notin"},
                {name: "!=", value: "!="},
            ]
        }
    }

    setOrganizationUnitFromSelection(e, index) {
        if (e) {
            if (Array.isArray(e)) {
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('value').setValue(e.map(item => item.perObjectDefinitionId));
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('valueText').setValue(e.map(item => item.longText || item.perObjectDefinitionText).join(', '));
            } else {
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('value').setValue(e?.perObjectDefinitionId);
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('valueText').setValue(e?.longText || e?.perObjectDefinitionText);
            }
        }
    }

    setPositionSelection(e, index) {
        if (e) {
            if (Array.isArray(e)) {
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('value').setValue(e.map(item => item.id));
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('valueText').setValue(e.map(item => item.longText).join(', '));
            } else {
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('value').setValue(e?.id);
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('valueText').setValue(e?.longText);
            }
        }
    }

    setPeopleSelection(e, index) {
        if (e) {
            if (Array.isArray(e)) {
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('value').setValue(e.map(item => item.id));
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('valueText').setValue(e.map(item => item.fullName).join(', '));
            } else {
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('value').setValue(e?.id);
                this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('valueText').setValue(e?.fullName);
            }
        }
    }

    onCancel() {
        let err = false;
        this.formArrayList.value?.forEach((item,index) => {
            if (item.entity == null || item.rules[0].field == null || item.rules[0].value == null) {
                this.formArrayList.removeAt(index)
            }
        });
        this.dynamicDialogRef.close(this.form.value.entityModel);
    }

    onSave() {
        let err = false;
        this.formArrayList.value?.forEach(item => {
            if (item.entity == null || item.rules[0].field == null || item.rules[0].value == null) {
                err = true;
            }
        })

        if (err) {
            this.uiToastMessage.showError("Tüm kriter alanlarının doldurulması beklenmektedir.");
            return;
        }
        this.dynamicDialogRef.close(this.form.value.entityModel);
    }

    getPickerData(ruleData, entityData) {
        const createModel = (val, text) => {
            let model;
            switch (entityData?.attribute.pickerType) {
                case 'organization':
                    model = new OrganizationDefinitionModel();
                    model.perObjectDefinitionId = val;
                    model.perObjectDefinitionText = text;
                    break;
                case 'people':
                    model = new PerPersonnelModel();
                    model.id = val;
                    model.fullName = text;
                    break;
                case 'position':
                    model = new PositionModel();
                    model.id = val;
                    model.longText = text;
                    break;
            }
            return model;
        };

        if (Array.isArray(ruleData.value)) {
            const texts = (ruleData.valueText || '').split(', ');
            return ruleData.value.map((v, i) => createModel(v, texts[i] || ''));
        } else {
            return [createModel(ruleData.value, ruleData.valueText)];
        }
    }

    isMultiSelect(index) {
        let selectedOperator = this.form.controls.entityModel['controls'][index].controls.rules.at(0).get('operator')?.value;
        return selectedOperator === "in" || selectedOperator === "notin";
    }

    setTitleSelection(e, index) {
        if (e) {
            this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('value').setValue(e?.value);
            this.form.controls.entityModel['controls'][index].controls['rules'].controls[0].get('valueText').setValue(e?.label);

        }
    }

}
